module.exports = __webpack_public_path__ + "img/TPCH.c3f8576f.png";